<template>
    <span> ${{ amount }} </span>
</template>
<script>
export default {
    name: "ValueAsCurrency",
    props: {
        value: {
            type: [Number, String],
            default: 0,
        },
        valueInCents: {
            type: Boolean,
            default: false,
        },
        showCents: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        amount() {
            return parseFloat(this.value).toFixed(2);
        },
    },
};
</script>
